// Hierarchical data structure for Sri Lankan administrative divisions
// Province -> District -> Electorate -> Divisional Secretariat Divisions

export type LocationData = Record<
  string, // Province
  Record<
    string, // District
    Record<
      string, // Electorate
      string[] // Divisional Secretariats
    >
  >
>

export const sriLankaData: LocationData = {
  // ─────────────────────────────────────────────
  // WESTERN PROVINCE | බස්නාහිර පළාත
  // ─────────────────────────────────────────────
  'Western Province | බස්නාහිර පළාත': {
    'Colombo | කොළඹ': {
      'Colombo North | කොළඹ උතුර': ['Colombo | කොළඹ'],
      'Colombo Central | කොළඹ මධ්‍යම': [
        'Colombo | කොළඹ',
        'Thimbirigasyaya | තිඹිරිගස්යාය',
      ],
      'Borella | බොරැල්ල': ['Thimbirigasyaya | තිඹිරිගස්යාය', 'Colombo | කොළඹ'],
      'Colombo East | කොළඹ නැගෙනහිර': [
        'Colombo | කොළඹ',
        'Thimbirigasyaya | තිඹිරිගස්යාය',
      ],
      'Colombo West | කොළඹ බස්නාහිර': ['Colombo | කොළඹ'],
      'Dehiwala | දෙහිවල': ['Dehiwala | දෙහිවල'],
      'Ratmalana | රත්මලාන': ['Dehiwala | දෙහිවල'],
      'Kolonnawa | කොළොන්නාව': ['Kolonnawa | කොළොන්නාව'],
      'Kotte | කෝට්ටේ': ['Sri Jayawardenepura Kotte | ශ්‍රී ජයවර්ධනපුර කෝට්ටේ'],
      'Kaduwela | කඩුවෙල': ['Kaduwela | කඩුවෙල'],
      'Avissawella | අවිස්සාවේල්ල': [
        'Seethawaka | සීතාවක',
        'Avissawella | අවිස්සාවේල්ල',
      ],
      'Homagama | හෝමාගම': ['Homagama | හෝමාගම', 'Padukka | පාදුක්ක'],
      'Maharagama | මහරගම': ['Maharagama | මහරගම'],
      'Kesbewa | කෙස්බෑව': ['Kesbewa | කෙස්බෑව'],
      'Moratuwa | මොරටුව': ['Moratuwa | මොරටුව', 'Dehiwala | දෙහිවල'],
    },

    'Gampaha | ගම්පහ': {
      'Ja-Ela | ජා-ඇල': ['Ja-Ela | ජා-ඇල'],
      'Wattala | වත්තල': ['Wattala | වත්තල'],
      'Kelaniya | කැලණිය': ['Kelaniya | කැලණිය'],
      'Biyagama | බියගම': ['Biyagama | බියගම'],
      'Dompe | දොම්පේ': ['Dompe | දොම්පේ'],
      'Gampaha | ගම්පහ': ['Gampaha | ගම්පහ'],
      'Minuwangoda | මිනුවන්ගොඩ': ['Minuwangoda | මිනුවන්ගොඩ'],
      'Attanagalla | අත්තනගල්ල': ['Attanagalla | අත්තනගල්ල'],
      'Mirigama | මිරිගම': ['Mirigama | මිරිගම'],
      'Divulapitiya | දිවුලපිටිය': ['Divulapitiya | දිවුලපිටිය'],
      'Mahara | මහර': ['Mahara | මහර'],
      'Katana | කටාන': ['Katana | කටාන'],
    },

    'Kalutara | කළුතර': {
      'Panadura | පානදුර': ['Panadura | පානදුර'],
      'Bandaragama | බන්ඩාරගම': ['Bandaragama | බන්ඩාරගම'],
      'Horana | හොරණ': ['Horana | හොරණ', 'Ingiriya | ඉංගිරිය'],
      'Bulathsinhala | බුලත්සිංහල': [
        'Bulathsinhala | බුලත්සිංහල',
        'Walallawita | වලල්ලාවිට',
      ],
      'Matugama | මතුගම': ['Matugama | මාතුගම', 'Dodangoda | දොඩංගොඩ'],
      'Kalutara | කළුතර': ['Kalutara | කළුතර'],
      'Beruwala | බේරුවල': ['Beruwala | බේරුවල'],
      'Agalawatta | අගලවත්ත': [
        'Agalawatta | අගලවත්ත',
        'Palindanuwara | පාලින්දනුවර',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // CENTRAL PROVINCE | මධ්‍යම පළාත
  // ─────────────────────────────────────────────
  'Central Province | මධ්‍යම පළාත': {
    'Kandy | මහනුවර': {
      'Senkadagala | සෙංකඩගල': ['Kandy Four Gravets | මහනුවර කඩවත් සතර'],
      'Galagedara | ගලාගෙදර': ['Galagedara | ගලාගෙදර'],
      'Harispattuwa | හරිස්පත්තුව': ['Harispattuwa | හරිස්පත්තුව'],
      'Yatinuwara | යතිනුවර': ['Yatinuwara | යතිනුවර'],
      'Udunuwara | උඩනුවර': ['Udunuwara | උඩනුවර'],
      'Kundasale | කුණ්ඩසාලේ': ['Kundasale | කුණ්ඩසාලේ', 'Tumpane | තුම්පනේ'],
      'Hewaheta | හේවාහැට': ['Hewaheta | හේවාහැට', 'Panvila | පන්විල'],
      'Ududumbara | උඩදුඹර': ['Ududumbara | උඩදුඹර'],
      'Teldeniya | තෑල්දෙණිය': ['Teldeniya | තෑල්දෙණිය', 'Minipe | මිනිපේ'],
      'Patadumbara | පාතදුඹර': ['Patadumbara | පාතදුඹර'],
      'Doluwa | දොළුව': ['Doluwa | දොළුව'],
      'Poojapitiya | පූජාපිටිය': ['Poojapitiya | පූජාපිටිය'],
      'Gampola | ගම්පොළ': ['Udapalatha | උඩපළාත'],
      'Nawalapitiya | නාවලපිටිය': ['Pasbage Korale | පස්බාගේ කෝරළේ'],
    },

    'Matale | මාතලේ': {
      'Matale | මාතලේ': [
        'Matale | මාතලේ',
        'Ukuwela | උකුවෙල',
        'Yatawatta | යටවත්ත',
      ],
      'Dambulla | දඹුල්ල': ['Dambulla | දඹුල්ල', 'Naula | නාඋල'],
      'Laggala-Pallegama | ලාගල-පල්ලේගම': [
        'Laggala | ලාගල',
        'Pallegama | පල්ලේගම',
      ],
      'Rattota | රත්තොට': [
        'Rattota | රත්තොට',
        'Wilgamuwa | විල්ගමුව',
        'Ambanganga Korale | අඹංගංග කෝරළේ',
      ],
    },

    'Nuwara Eliya | නුවරඑළිය': {
      'Nuwara Eliya-Maskeliya | නුවරඑළිය-මාස්කෙළිය': [
        'Nuwara Eliya | නුවරඑළිය',
        'Ambagamuwa | අඹගමුව',
        'Maskeliya | මාස්කෙළිය',
      ],
      'Kothmale | කොත්මලේ': ['Kothmale | කොත්මලේ'],
      'Hanguranketha | හංගුරන්කෙත': [
        'Hanguranketha | හංගුරන්කෙත',
        'Patana | පතන',
      ],
      'Walapane | වලපනේ': ['Walapane | වලපනේ'],
    },
  },

  // ─────────────────────────────────────────────
  // SOUTHERN PROVINCE | දකුණු පළාත
  // ─────────────────────────────────────────────
  'Southern Province | දකුණු පළාත': {
    'Galle | ගාල්ල': {
      'Galle | ගාල්ල': [
        'Galle Four Gravets | ගාල්ල කඩවත් සතර',
        'Akmeemana | අක්මීමන',
      ],
      'Habaraduwa | හබරාදුව': [
        'Habaraduwa | හබරාදුව',
        'Welivitiya-Divithura | වෙලිවිටිය-දිවිතුර',
      ],
      'Baddegama | බද්දේගම': ['Baddegama | බද්දේගම', 'Niyagama | නියාගම'],
      'Ratgama | රත්ගම': ['Imaduwa | ඉමදූව', 'Yakkalamulla | යක්කලමුල්ල'],
      'Ambalangoda | අම්බලන්ගොඩ': ['Ambalangoda | අම්බලන්ගොඩ'],
      'Balapitiya | බලපිටිය': ['Balapitiya | බලපිටිය'],
      'Bentara-Elpitiya | බෙන්තර-එල්පිටිය': [
        'Elpitiya | එල්පිටිය',
        'Bentara-Elpitiya | බෙන්තර-එල්පිටිය',
      ],
      'Hiniduma | හිනිදුම': [
        'Neluwa | නෙළුව',
        'Nagoda | නාගොඩ',
        'Thawalama | තාවලම',
      ],
      'Karandeniya | කරන්දෙණිය': ['Karandeniya | කරන්දෙණිය'],
    },

    'Matara | මාතර': {
      'Matara | මාතර': ['Matara | මාතර', 'Welipitiya | වෙලිපිටිය'],
      'Weligama | වැලිගම': ['Weligama | වැලිගම', 'Malimbada | මාලිම්බඩ'],
      'Akuressa | අකුරැස්ස': ['Akuressa | අකුරැස්ස', 'Athuraliya | අතුරලිය'],
      'Kamburupitiya | කඹුරුපිටිය': [
        'Kamburupitiya | කඹුරුපිටිය',
        'Mulatiyana | මුලටියාන',
      ],
      'Hakmana | හක්මන': ['Hakmana | හක්මන'],
      'Deniyaya | දෙනියාය': ['Kotapola | කොටපොළ', 'Pasgoda | පස්ගොඩ'],
      'Devinuwara | දෙවිනුවර': [
        'Devinuwara | දෙවිනුවර',
        'Dickwella | දික්වෙල',
        'Kirinda Puhulwella | කිරින්ද පුහුල්වෙල',
      ],
    },

    'Hambantota | හම්බන්තොට': {
      'Hambantota | හම්බන්තොට': [
        'Hambantota | හම්බන්තොට',
        'Ambalantota | අඹලන්තොට',
        'Suriyawewa | සූරියවැව',
      ],
      'Tangalle | තංගල්ල': [
        'Tangalle | තංගල්ල',
        'Weeraketiya | වීරකෙටිය',
        'Katuwana | කටුවාන',
      ],
      'Tissamaharama | තිස්සමහාරාම': [
        'Tissamaharama | තිස්සමහාරාම',
        'Lunugamvehera | ලුණුගම්වෙහෙර',
      ],
      'Beliatta | බෙලිඅත්ත': [
        'Beliatta | බෙලිඅත්ත',
        'Angunakolapelessa | අංගුනකොළපෙලෙස්ස',
      ],
      'Mulkirigala | මුල්කිරිගල': [
        'Mulkirigala | මුල්කිරිගල',
        'Okewela | ඔකේවෙල',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // NORTHERN PROVINCE | උතුරු පළාත
  // ─────────────────────────────────────────────
  'Northern Province | උතුරු පළාත': {
    'Jaffna | යාපනය': {
      'Kayts | කයිට්ස්': [
        'Kayts | කයිට්ස්',
        'Velanai | වේලනේ',
        'Delft | දෙල්ෆ්ට්',
      ],
      'Vaddukoddai | වඩ්ඩුකොඩ්ඩේ': ['Vaddukoddai | වඩ්ඩුකොඩ්ඩේ'],
      'Kankesanthurai | කන්කසන්තුරේ': [
        'Valikamam North | වලිකාමම් උතුර',
        'Valikamam North-West | වලිකාමම් වයඹ',
      ],
      'Manipay | මනිපේ': [
        'Sandilipay | සන්දිලිපේ',
        'Valikamam South | වලිකාමම් දකුණ',
      ],
      'Kopay | කෝපේ': ['Kopay | කෝපේ', 'Valikamam East | වලිකාමම් නැගෙනහිර'],
      'Uduppiddy | උඩුප්පිඩ්ඩි': [
        'Tellippalai | තෙල්ලිප්පලේ',
        'Valikamam West | වලිකාමම් බස්නාහිර',
      ],
      'Point Pedro | පොයින්ට් පෙඩ්රෝ': [
        'Point Pedro | පොයින්ට් පෙඩ්රෝ',
        'Vadamaradchi North | වඩමාරච්චි උතුර',
      ],
      'Chavakachcheri | චාවකච්චේරි': [
        'Chavakachcheri | චාවකච්චේරි',
        'Vadamaradchi South-West | වඩමාරච්චි දකුණ-බස්නාහිර',
      ],
      'Nallur | නල්ලූර්': [
        'Nallur | නල්ලූර්',
        'Islands North | දූපත් උතුර',
        'Islands South | දූපත් දකුණ',
      ],
      'Jaffna | යාපනය': [
        'Jaffna | යාපනය',
        'Vadamaradchi East | වඩමාරච්චි නැගෙනහිර',
      ],
    },

    'Kilinochchi | කිලිනොච්චිය': {
      'Kilinochchi | කිලිනොච්චිය': [
        'Kilinochchi | කිලිනොච්චිය',
        'Karachchi | කරච්චි',
        'Poonakary | පූනකාරි',
        'Pachchilaipalli | පච්චිලෛපල්ලි',
      ],
    },

    'Mannar | මන්නාරම': {
      'Mannar | මන්නාරම': [
        'Mannar | මන්නාරම',
        'Musali | මූසලි',
        'Nanattan | නානාත්තන්',
        'Manthai West | මන්තේ බස්නාහිර',
        'Madhu | මාදු',
      ],
    },

    'Vavuniya | වවුනියාව': {
      'Vavuniya | වවුනියාව': [
        'Vavuniya | වවුනියාව',
        'Vavuniya North | වවුනියාව උතුර',
        'Vavuniya South | වවුනියාව දකුණ',
        'Vengalacheddikulam | වෙංගලච්චෙඩ්ඩිකුලම',
      ],
    },

    'Mullaitivu | මුලතිව්': {
      'Mullaitivu | මුලතිව්': [
        'Mullaitivu | මුලතිව්',
        'Maritimepattu | මුහුදුබඩපත්තුව',
        'Oddusuddan | ඔඩ්ඩුසුඩ්ඩාන්',
        'Puthukkudiyiruppu | පුතුක්කුඩියිරුප්පු',
        'Thunukkai | තුනුක්කේ',
        'Welioya | වෙලිඔය',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // EASTERN PROVINCE | නැගෙනහිර පළාත
  // ─────────────────────────────────────────────
  'Eastern Province | නැගෙනහිර පළාත': {
    'Batticaloa | මඩකලපුව': {
      'Batticaloa | මඩකලපුව': [
        'Batticaloa | මඩකලපුව',
        'Manmunai North | මන්මුනේ උතුර',
        'Manmunai West | මන්මුනේ බස්නාහිර',
        'Manmunai South West | මන්මුනේ දකුණ-බස්නාහිර',
      ],
      'Paddiruppu | පඩ්ඩිරුප්පු': [
        'Manmunai South-Eruvil Pattu | මන්මුනේ දකුණ-ඒරාවිල් පත්තු',
        'Porativu Pattu | පොරතිව් පත්තු',
      ],
      'Kalkudah | කල්කුඩා': [
        'Kalkudah | කල්කුඩා',
        'Eravur Pattu | ඒරාවූර් පත්තු',
        'Eravur Town | ඒරාවූර් නගරය',
        'Koralai Pattu | කෝරලේ පත්තු',
        'Koralai Pattu North | කෝරලේ පත්තු උතුර',
        'Koralai Pattu South | කෝරලේ පත්තු දකුණ',
        'Koralai Pattu West | කෝරලේ පත්තු බස්නාහිර',
      ],
    },

    'Ampara | අම්පාර': {
      'Ampara | අම්පාර': [
        'Ampara | අම්පාර',
        'Uhana | උහාන',
        'Damana | දාමන',
        'Dehiattakandiya | දෙහිඅත්තකන්දිය',
        'Padiyathalawa | පාදියතලාව',
        'Mahaoya | මහඔය',
      ],
      'Samanthurai | සාමන්තුරේ': [
        'Samanthurai | සාමන්තුරේ',
        'Navithanveli | නාවිතන්වේලි',
        'Alayadivembu | ආලෛයාදිවෙඹු',
        'Irakkamam | ඉරක්කාමම්',
      ],
      'Kalmunai | කල්මුනේ': [
        'Kalmunai | කල්මුනේ',
        'Karaitivu | කාරෛතිව්',
        'Sainthamaruthu | සේන්ත මාරුදු',
        'Addalaichenai | අඩ්ඩාලෛච්චේනේ',
      ],
      'Pottuvil | පොත්තුවිල්': [
        'Pottuvil | පොත්තුවිල්',
        'Lahugala | ලාහුගල',
        'Akkaraipattu | අක්කරෛපත්තු',
        'Tirukkovil | තිරුකෝවිල',
      ],
    },

    'Trincomalee | ත්‍රිකුණාමලය': {
      'Trincomalee | ත්‍රිකුණාමලය': [
        'Trincomalee | ත්‍රිකුණාමලය',
        'Thambalagamuwa | තඹලගමුව',
        'Kinniya | කිණ්ණියා',
        'Morawewa | මොරවැව',
      ],
      'Muttur | මුතූර්': ['Muttur | මුතූර්', 'Padavi Sripura | පදවි ශ්‍රීපුර'],
      'Seruvila | සේරුවිල': [
        'Seruvila | සේරුවිල',
        'Kantale | කන්තලේ',
        'Verugal | වේරුගල',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // NORTH WESTERN PROVINCE | වයඹ පළාත
  // ─────────────────────────────────────────────
  'North Western Province | වයඹ පළාත': {
    'Kurunegala | කුරුණෑගල': {
      'Kurunegala | කුරුණෑගල': [
        'Kurunegala | කුරුණෑගල',
        'Narammala | නාරම්මල',
        'Maspotha | මාස්පොත',
      ],
      'Mawathagama | මාවතගම': [
        'Mawathagama | මාවතගම',
        'Udubaddawa | උඩුබද්දාව',
      ],
      'Galgamuwa | ගල්ගමුව': [
        'Galgamuwa | ගල්ගමුව',
        'Ehetuwewa | ඇහැටුවැව',
        'Rasnayakapura | රස්නායකපුර',
      ],
      'Nikaweratiya | නිකවැරටිය': [
        'Nikaweratiya | නිකවැරටිය',
        'Polpithigama | පොල්පිතිගම',
      ],
      'Wariyapola | වාරියපොළ': ['Wariyapola | වාරියපොළ', 'Ganewatta | ගනේවත්ත'],
      'Panduwasnuwara | පඬුවස්නුවර': [
        'Panduwasnuwara | පඬුවස්නුවර',
        'Kotavehera | කොටවෙහෙර',
      ],
      'Bingiriya | බිංගිරිය': ['Bingiriya | බිංගිරිය', 'Giribawa | ගිරිබාව'],
      'Katugampola | කටුගම්පොළ': [
        'Kurunegala | කුරුණෑගල',
        'Weerambugedara | වීරඹුගෙදර',
      ],
      'Kuliyapitiya | කුලියාපිටිය': [
        'Kuliyapitiya West | කුලියාපිටිය බස්නාහිර',
        'Kuliyapitiya East | කුලියාපිටිය නැගෙනහිර',
      ],
      'Dambadeniya | දඹදෙණිය': ['Dambadeniya | දඹදෙණිය'],
      'Polgahawela | පොල්ගහවෙල': ['Polgahawela | පොල්ගහවෙල'],
      'Hiriyala | හිරියාල': ['Ibbagamuwa | ඉබ්බාගමුව'],
      'Dodangaslanda | දොඩංගස්ලන්ද': ['Alawwa | අලව්ව'],
      'Rideegama | රිදීගම': ['Rideegama | රිදීගම'],
      'Yapahuwa | යාපහුව': ['Mahawa | මහව'],
    },

    'Puttalam | පුත්තලම': {
      'Puttalam | පුත්තලම': [
        'Puttalam | පුත්තලම',
        'Kalpitiya | කල්පිටිය',
        'Mundalama | මුන්ඩලම',
      ],
      'Anamaduwa | අනමඩුව': [
        'Anamaduwa | අනමඩුව',
        'Nawagattegama | නාවගත්තේගම',
      ],
      'Chilaw | හලාවත': [
        'Chilaw | හලාවත',
        'Madampe | මඩම්පේ',
        'Arachchikattuwa | ආරච්චිකට්ටුව',
      ],
      'Nattandiya | නාත්තන්ඩිය': ['Nattandiya | නාත්තන්ඩිය'],
      'Wennappuwa | වෙන්නප්පුව': [
        'Wennappuwa | වෙන්නප්පුව',
        'Dankotuwa | දංකොටුව',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // NORTH CENTRAL PROVINCE | උතුරු මැද පළාත
  // ─────────────────────────────────────────────
  'North Central Province | උතුරු මැද පළාත': {
    'Anuradhapura | අනුරාධපුර': {
      'Anuradhapura East | අනුරාධපුර නැගෙනහිර': [
        'Nuwaragam Palatha East | නුවරගම් පළාත නැගෙනහිර',
        'Thalawa | තලාව',
        'Tirappane | තිරප්පනේ',
      ],
      'Anuradhapura West | අනුරාධපුර බස්නාහිර': [
        'Nuwaragam Palatha Central | නුවරගම් පළාත මධ්‍යම',
        'Palagala | පාලාගල',
        'Rambewa | රඹෑව',
      ],
      'Medawachchiya | මේදවච්චිය': [
        'Medawachchiya | මේදවච්චිය',
        'Kebithigollewa | කෙබිතිගොල්ලෑව',
        'Padaviya | පදවිය',
      ],
      'Horowpothana | හොරොව්පොතාන': [
        'Horowpothana | හොරොව්පොතාන',
        'Kahatagasdigiliya | කහටගස්දිගිලිය',
      ],
      'Kalawewa | කලාවැව': [
        'Kalawewa | කලාවැව',
        'Nochchiyagama | නොච්චියාගම',
        'Galenbindunuwewa | ගලෙන්බිඳුනුවෑව',
      ],
      'Mihintale | මිහින්තලේ': [
        'Mihintale | මිහින්තලේ',
        'Ipalogama | ඉපලෝගම',
        'Nachchadoowa | නාච්චාදූව',
      ],
      'Kekirawa | කැකිරාව': [
        'Kekirawa | කැකිරාව',
        'Galnewa | ගල්නෑව',
        'Rajanganaya | රාජාංගනය',
      ],
      'Minneriya | මින්නේරිය': [
        'Hingurakgoda | හිංගුරක්ගොඩ',
        'Mahavilachchiya | මහවිලච්චිය',
      ],
    },

    'Polonnaruwa | පොළොන්නරුව': {
      'Polonnaruwa | පොළොන්නරුව': [
        'Polonnaruwa | පොළොන්නරුව',
        'Thamankaduwa | තමන්කඩුව',
        'Dimbulagala | දිඹුලාගල',
        'Welikanda | වෙලිකන්ද',
      ],
      'Medirigiriya | මැදිරිගිරිය': [
        'Medirigiriya | මැදිරිගිරිය',
        'Lankapura | ලංකාපුර',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // UVA PROVINCE | ඌව පළාත
  // ─────────────────────────────────────────────
  'Uva Province | ඌව පළාත': {
    'Badulla | බදුල්ල': {
      'Badulla | බදුල්ල': [
        'Badulla | බදුල්ල',
        'Hali-Ela | හාලිඇල',
        'Ella | ඇල්ල',
      ],
      'Bandarawela | බණ්ඩාරවෙල': [
        'Bandarawela | බණ්ඩාරවෙල',
        'Haputale | හාපුතලේ',
        'Haldummulla | හල්දුම්මුල්ල',
      ],
      'Welimada | වෙලිමඩ': [
        'Welimada | වෙලිමඩ',
        'Uva Paranagama | ඌව පාරනගම',
        'Meegahakivula | මීගහකිවුල',
      ],
      'Passara | පස්සර': [
        'Passara | පස්සර',
        'Lunugala | ලූනුගල',
        'Kandaketiya | කන්දකැටිය',
      ],
      'Mahiyanganaya | මහියංගනය': ['Mahiyanganaya | මහියංගනය'],
      'Viyaluwa | වියළුව': [
        'Soranathota | සොරනාතොට',
        'Rideemaliyadda | රිදීමාලියද්ද',
      ],
    },

    'Monaragala | මොණරාගල': {
      'Monaragala | මොණරාගල': [
        'Monaragala | මොණරාගල',
        'Medagama | මේදගම',
        'Madulla | මඩුල්ල',
      ],
      'Wellawaya | වැල්ලවාය': [
        'Wellawaya | වැල්ලවාය',
        'Thanamalvila | තනමල්විල',
        'Sevanagala | සේවනගල',
      ],
      'Bibile | බිබිල': ['Bibile | බිබිල'],
      'Buttala | බුත්තල': [
        'Buttala | බුත්තල',
        'Kataragama | කතරගම',
        'Siyambalanduwa | සියඹලාන්දුව',
      ],
    },
  },

  // ─────────────────────────────────────────────
  // SABARAGAMUWA PROVINCE | සබරගමුව පළාත
  // ─────────────────────────────────────────────
  'Sabaragamuwa Province | සබරගමුව පළාත': {
    'Ratnapura | රත්නපුර': {
      'Ratnapura | රත්නපුර': [
        'Ratnapura | රත්නපුර',
        'Kuruvita | කුරුවිට',
        'Eheliyagoda | ඇහැලියගොඩ',
      ],
      'Eheliyagoda | ඇහැලියගොඩ': [
        'Eheliyagoda | ඇහැලියගොඩ',
        'Kiriella | කිරිඇල්ල',
        'Weligepola | වෙලිගෙපොළ',
      ],
      'Pelmadulla | පෑල්මඩුල්ල': [
        'Pelmadulla | පෑල්මඩුල්ල',
        'Opanayaka | ඔපනායක',
        'Ayagama | අයගම',
      ],
      'Balangoda | බලන්ගොඩ': [
        'Balangoda | බලන්ගොඩ',
        'Imbulpe | ඉඹුල්පේ',
        'Kahawatta | කහවත්ත',
      ],
      'Rakwana | රක්වාන': ['Rakwana | රක්වාන'],
      'Nivithigala | නිවිතිගල': ['Nivithigala | නිවිතිගල'],
      'Kalawana | කළවාන': ['Kalawana | කළවාන'],
      'Kolonna | කොළොන්න': ['Kolonna | කොළොන්න', 'Embilipitiya | එඹිලිපිටිය'],
    },

    'Kegalle | කෑගල්ල': {
      'Kegalle | කෑගල්ල': ['Kegalle | කෑගල්ල', 'Warakapola | වාරකාපොළ'],
      'Rambukkana | රඹුක්කන': ['Rambukkana | රඹුක්කන'],
      'Mawanella | මාවනැල්ල': ['Mawanella | මාවනැල්ල', 'Dehiovita | දෙහිඔවිට'],
      'Aranayaka | ඇරණායක': ['Aranayaka | ඇරණායක'],
      'Yatiyanthota | යටියන්තොට': [
        'Yatiyanthota | යටියන්තොට',
        'Kitulgala | කිතුල්ගල',
      ],
      'Ruwanwella | රුවන්වෙල': ['Ruwanwella | රුවන්වෙල'],
      'Deraniyagala | දෙරණියගල': ['Deraniyagala | දෙරණියගල'],
      'Dedigama | දෙදිගම': ['Dedigama | දෙදිගම'],
      'Galigamuwa | ගලිගමුව': [
        'Galigamuwa | ගලිගමුව',
        'Bulathkohupitiya | බුලත්කොහුපිටිය',
      ],
    },
  },
}
